import {APIClient} from './APIClient';
import {API_URL} from '../settings/local_settings';

/**
 * El semáforo de una columna del Tablero, para la tuerca de su encabezado.
 *
 * El GET trae los umbrales vigentes (en fracción: 0,15 = 15 %, y también los días: 0,04 = 4 días) y
 * si la columna se pinta. El PUT escribe si la columna se pinta y, en una agencia con las alertas
 * convertidas (Centro de Alertas v2, contrato v2 §4), también los umbrales del color: ahí el color y
 * el aviso son dos números distintos, así que tocar el color no cambia cuándo avisa.
 */
export class DashboardColumnColorService {

    static _url(columnName) {
        // El identificador de una columna comparativa lleva `||`, y puede traer espacios y
        // paréntesis: sin encodear, la barra y el resto rompen la ruta.
        return `${API_URL}agency/dashboard-column-color/${encodeURIComponent(columnName)}/`;
    }

    static async load(columnName) {
        const response = await new APIClient(this._url(columnName)).call('GET');

        if (response.status === 'OK') {
            return response.result;
        }

        throw new Error(response.status || 'ERROR');
    }

    static async setShowsColor(columnName, showsColor) {
        const response = await new APIClient(this._url(columnName)).call('PUT', {shows_color: showsColor});

        if (response.status === 'OK') {
            return response.result;
        }

        throw new Error(response.status || 'ERROR');
    }

    /**
     * Los umbrales del color, en HUMANO (15 = 15 %, 4 = 4 días): el backend los pasa a fracción. Devuelve la
     * respuesta entera y no tira: la tuerca necesita el código tipado (`INVALID_VALUE` con su campo) para
     * marcar el que está mal.
     */
    static saveColumnLevels(columnName, levels) {
        return new APIClient(this._url(columnName)).call('PUT', {levels});
    }

    /**
     * «Prenderlo» desde la tuerca: el mismo POST parcial de la pantalla de alertas, sólo el interruptor
     * del indicador (la lista vacía no toca ningún umbral; ver `alertRulesApi.saveSystemRules`).
     */
    static setAlertActive(indicator, isActive) {
        return new APIClient(`${API_URL}agency/alerts-configuration`)
            .call('POST', {[indicator]: {is_active: isActive, sensitivity_values: []}});
    }
}
